import React, { useRef, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Sidebar from "../Sidebar";
import { productOptions } from "../Options";
export default function EditBalanceSheet() {
  //state definintion
  const [form, setForm] = useState({
    marketingYear: "",
    carryIn: "",
    production: "",
    import: "",
    millConsumption: "",
    export: "",
    carryOut: "",
    commodities: "",
  });

  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);
  const ref5 = useRef(null);
  const ref6 = useRef(null);
  const ref7 = useRef(null);

  //year handler
  const yearHandler = (e) => {
    setForm({ ...form, marketingYear: e.target.value });
  };

  //caaryIn handler
  const carryInHandler = (e) => {
    setForm({ ...form, carryIn: e.target.value });
  };

  //production handler
  const productionHandler = (e) => {
    setForm({ ...form, production: e.target.value });
  };

  //import handler
  const importHandler = (e) => {
    setForm({ ...form, import: e.target.value });
  };

  //millConsumption
  const millConsumptionHandler = (e) => {
    setForm({ ...form, millConsumption: e.target.value });
  };

  //export handler
  const exportHandler = (e) => {
    setForm({ ...form, export: e.target.value });
  };

  //carryOut handler
  const carryOutHandler = (e) => {
    setForm({ ...form, carryOut: e.target.value });
  };

  const commoditiesHandler = (e) => {
    const val = e.target.value.toLowerCase();
    setForm({ ...form, commodity: val });
  };
  const { _id } = useParams();
  const gerrit = async () => {
    const token = sessionStorage.getItem("token");
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/getBSs/${_id}`,
      {
        headers: {
          "x-access-token": token,
        },
      }
    );
    const data = await response.json();
    setForm({
      ...form,
      marketingYear: data.marketingYear,
      carryIn: data.carryIn,
      production: data.production,
      import: data.import,
      millConsumption: data.millConsumption,
      export: data.export,
      carryOut: data.carryOut,
      commodity: data.commodity,
    });
  };

  useEffect(() => {
    gerrit();
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = sessionStorage.getItem("token");
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/updateBS/${_id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
        body: JSON.stringify(form),
      }
    );
    // .then(console.log(form))
    // .then(console.log("Successfully submitted!"))}

    return (
      <>
        <div className="sidebar">
          <Sidebar />
        </div>
        <div id="bydrop">
          <form onSubmit={handleSubmit}>
            <h1>Update Balance Sheet</h1>
            <div className="row">
              <div className="col-md-6">
                <label for="formGroupExampleInput" class="form-label">
                  Marketing Year
                </label>
                <div class="input-group input-group-sm mb-3">
                  <select
                    className="form-select"
                    ref={ref1}
                    id="num-value"
                    value={form.marketingYear}
                    onChange={yearHandler}
                    required
                    aria-label="Select example"
                  >
                    <option value="">Select year</option>
                    <option value="2025-26">2025-26</option>
                    <option value="2024-25">2024-25</option>
                    <option value="2023-24">2023-24</option>
                    <option value="2022-23">2022-23</option>
                    <option value="2021-22">2021-22</option>
                    <option value="2020-21">2020-21</option>
                    <option value="2019-20">2019-20</option>
                    <option value="2018-19">2018-19</option>
                    <option value="2017-18">2017-18</option>
                    <option value="2016-17">2016-17</option>
                    <option value="2015-16">2015-16</option>
                    <option value="2014-15">2014-15</option>
                    <option value="2013-14">2013-14</option>
                    <option value="2012-13">2012-13</option>
                    <option value="2011-12">2011-12</option>
                    <option value="2010-11">2010-11</option>
                  </select>{" "}
                </div>
              </div>
              <div className="col-md-6">
                <label for="formGroupExampleInput" class="form-label">
                  Carry In
                </label>
                <div class="input-group input-group-sm mb-3">
                  <input
                    value={form.carryIn}
                    required
                    type="number"
                    min={0}
                    ref={ref2}
                    onChange={carryInHandler}
                    class="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <label for="formGroupExampleInput" class="form-label">
                  Production
                </label>
                <div class="input-group input-group-sm mb-3">
                  <input
                    value={form.production}
                    required
                    type="number"
                    min={0}
                    ref={ref3}
                    onChange={productionHandler}
                    class="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <label for="formGroupExampleInput" class="form-label">
                  Import
                </label>
                <div class="input-group input-group-sm mb-3">
                  <input
                    value={form.import}
                    required
                    type="number"
                    min={0}
                    ref={ref4}
                    onChange={importHandler}
                    class="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <label for="formGroupExampleInput" class="form-label">
                  Mill Consumption
                </label>
                <div class="input-group input-group-sm mb-3">
                  <input
                    value={form.millConsumption}
                    required
                    type="number"
                    min={0}
                    ref={ref5}
                    onChange={millConsumptionHandler}
                    class="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <label for="formGroupExampleInput" class="form-label">
                  Export
                </label>
                <div class="input-group input-group-sm mb-3">
                  <input
                    value={form.export}
                    required
                    type="number"
                    min={0}
                    ref={ref6}
                    onChange={exportHandler}
                    class="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <label for="formGroupExampleInput" class="form-label">
                  Carry Out
                </label>
                <div class="input-group input-group-sm mb-3">
                  <input
                    value={form.carryOut}
                    required
                    type="number"
                    ref={ref7}
                    onChange={carryOutHandler}
                    class="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <label for="formGroupExampleInput" class="form-label">
                  Commodity
                </label>
                <select
                  className="form-select"
                  value={form.commodity}
                  id="inputGroupSelect04"
                  aria-label="Example select with button addon"
                  onChange={commoditiesHandler}
                  required
                >
                  <option value="">Commodity</option>
                  {productOptions.map((productOption) => (
                    <option
                      key={productOption.value}
                      value={productOption.name}
                    >
                      {productOption.text}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <button type="submit" className="btn btn-secondary btn-lg">
              Submit
            </button>
          </form>
        </div>
      </>
    );
  };
}
